import React from 'react';
import { Chip } from 'primereact/chip';
import { useLanguage } from '../../../../contexts/LanguageContext';

/**
 * Eğitim Kataloğu Detay sayfasının ÜST form bloğunda, form alanlarıyla Sil/Kaydet butonları
 * arasında gösterilen salt-okunur özet — sayfanın en altındaki Eğitmenler / İçerik-Kazanım /
 * Ön Koşullar sekmelerinden (`TrainingCatalogDetailTabs.jsx`) AYRI, onlarla anlık senkron değil.
 *
 * Kaynağı doğrudan `GetById` cevabı (`data` prop'u) — `instructors`, `trainingContent`,
 * `trainingOutcome`, `preconditions` alanları backend'in üst özet için eklediği alanlar
 * (bkz. docs/LMS-Egitim-Katalogu-Detay-Ozeti-BE-Istek-Notu.md). İçerik/kazanım burada tek
 * satır — backend zaten yalnızca aktif dili (X-App-Language) döndürüyor, 6 dilin tamamı değil.
 */
const TrainingCatalogSummary = ({ data }) => {
    const { th } = useLanguage();

    const instructors = data?.instructors || [];
    const preconditions = data?.preconditions || [];
    const emptyValue = th('trainingCatalog.summary.emptyValue');

    return (
        <div className="surface-100 border-round p-3 mt-2">
            <h3 className="mt-0 mb-3" style={{ fontSize: '1rem' }}>
                {th('trainingCatalog.summary.title')}
            </h3>

            <div className="grid text-sm">
                <div className="col-12 md:col-4">
                    <strong>{th('trainingCatalog.summary.instructorsLabel')}:</strong>
                    <div className="mt-2">
                        {instructors.length === 0 ? (
                            <span className="text-color-secondary">{emptyValue}</span>
                        ) : (
                            <div className="flex flex-wrap gap-2">
                                {instructors.map((instructor) => (
                                    <Chip key={instructor.id} label={instructor.userFullName || instructor.userEmail} />
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div className="col-12 md:col-4">
                    <div>
                        <strong>{th('trainingCatalog.summary.contentLabel')}:</strong> {data?.trainingContent || emptyValue}
                    </div>
                    <div className="mt-2">
                        <strong>{th('trainingCatalog.summary.outcomeLabel')}:</strong> {data?.trainingOutcome || emptyValue}
                    </div>
                </div>

                <div className="col-12 md:col-4">
                    <strong>{th('trainingCatalog.summary.preconditionsLabel')}:</strong>
                    <div className="mt-2">
                        {preconditions.length === 0 ? (
                            <span className="text-color-secondary">{emptyValue}</span>
                        ) : (
                            <div className="flex flex-wrap gap-2">
                                {preconditions.map((precondition) => (
                                    <Chip key={precondition.id} label={precondition.precondition || precondition.preconditionCode} />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TrainingCatalogSummary;
